import { 
  appendText,
  getText
} from '../../assets/js/text-renderer';

import '../../assets/css/index-blocks.scss';
import '../shared/cta/cta'

document.addEventListener('DOMContentLoaded', async () => {
  if (
    DEVELOPMENT || (
    window['__PRERENDER_INJECTED'] && 
    window['__PRERENDER_INJECTED'].render_text)
  ) await loadText();
});

const loadText = async () => {
  const data = await getText('platform/intelek-data-api');
  const content = data.stories[0].content;

  setHeroContent(content);
  setFeaturedContent(content);
  setFeatureCardsContent(content);
  setQuotedFeaturesContent(content);
  setFeatureExampleContent(content);
  await setCustomCtaContent();

  window.dispatchEvent(
    new CustomEvent('rendered-text', { detail: 'keywords' })
  );
  window.dispatchEvent(
    new CustomEvent('rendered-text', { detail: 'content' })
  );
};

function setHeroContent(content) {
  appendText(content.hero_title, 'hero-title');
  appendText(content.summary, 'summary');
};

function setFeaturedContent(content) {
  appendText(content.featured[0].text, 'featured-0');
  appendText(content.featured[1].text, 'featured-1');
  appendText(content.featured[2].text, 'featured-2');
  appendText(content.featured[3].text, 'featured-3');
};

function setFeatureCardsContent(content) {
  appendText(content.feature_cards[0].title, 'feature-card-0-title');
  appendText(content.feature_cards[0].text, 'feature-card-0-text');
  appendText(content.feature_cards[1].title, 'feature-card-1-title');
  appendText(content.feature_cards[1].text, 'feature-card-1-text');
  appendText(content.feature_cards[2].title, 'feature-card-2-title');
  appendText(content.feature_cards[2].text, 'feature-card-2-text');
};

function setQuotedFeaturesContent(content) {
  appendText(content.quoted_features[0].richtext, 'quoted-feature-text-0');
  appendText(content.quoted_features[0].text, 'quoted-feature-quote-0');
  appendText(content.quoted_features[1].richtext, 'quoted-feature-text-1');
  appendText(content.quoted_features[1].text, 'quoted-feature-quote-1');
};

function setFeatureExampleContent(content) {
  appendText(content.feature_example[0].text, 'text-example-0');
  appendText(content.feature_example[1].text, 'text-example-1');
  appendText(content.feature_example[2].text, 'text-example-2');
};

async function setCustomCtaContent() {
  const ctaData = await getText('platform/shared/cta');
  const ctaContent = ctaData.stories[0].content.block[0];

  const customCtaContainer = document.getElementById('custom-cta');
  const customCtaEl = document.createElement('custom-cta');
  customCtaEl.setAttribute('title', ctaContent.title)
  customCtaEl.setAttribute('description', ctaContent.description)
  customCtaEl.setAttribute('primary-button-text', ctaContent.btn_primary)
  customCtaEl.setAttribute('primary-button-url', '/plataforma/start-trial/')
  customCtaEl.setAttribute('secondary-button-text', ctaContent.btn_secondary)
  customCtaEl.setAttribute('secondary-button-url', '/plataforma/book-demo-form/')
  customCtaContainer.appendChild(customCtaEl);

  window.dispatchEvent(
    new CustomEvent("rendered-text", { detail: "cta" })
  );
};